import { FILTER_PARAMS } from '~/constants/filtering';

/**
 * Check if the URL has some filters query params applied
 *
 * @returns {boolean}
 */
const currentUrlHasShopifyFilterQueryParams = (currentQueryString = window.location.search) => {
  return currentQueryString.includes(FILTER_PARAMS.FILTER);
};

/**
 * Check if the URL has some sort query params applied
 *
 * @returns {boolean}
 */
const currentUrlHasShopifySortQueryParams = (currentQueryString = window.location.search) => {
  return currentQueryString.includes(FILTER_PARAMS.SORT_BY);
};

export { currentUrlHasShopifyFilterQueryParams, currentUrlHasShopifySortQueryParams };
